/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * K3X API
 * The K3X API description
 * OpenAPI spec version: 1.0
 */

export type ListSuperadminActivityActorType = typeof ListSuperadminActivityActorType[keyof typeof ListSuperadminActivityActorType];


export const ListSuperadminActivityActorType = {
  organization_member: 'organization_member',
  agent: 'agent',
  import: 'import',
  system: 'system',
  k3x_support: 'k3x_support',
  user: 'user',
  integration: 'integration',
  reveal: 'reveal',
} as const;
